import React from 'react'
import clsx from 'clsx'

import Tooltip from '../Tooltip'

import useStyles from './styles'

// Mostly use div props
interface OverflowTextProps extends React.HTMLAttributes<HTMLDivElement> {
  autoPlace?: boolean
}

const OverflowText: React.FC<OverflowTextProps> = ({
  autoPlace,
  children,
  className,
  ...props
}) => {
  const elemRef = React.useRef<HTMLDivElement>()

  const classes = useStyles()

  let elem = (
    <div ref={elemRef} className={clsx(classes.root, className)} {...props}>
      {children}
    </div>
  )

  // Show tooltip if text is overflowing
  if (elemRef.current) {
    const element = elemRef.current
    if (element.offsetWidth < element.scrollWidth) {
      elem = (
        <Tooltip
          title={children}
          placement={autoPlace ? undefined : 'right'}
          arrow
        >
          {elem}
        </Tooltip>
      )
    }
  }

  return elem
}

export default OverflowText
